import Navbar from './components/Navbar/Navbar';
// import logo from './logo.svg';
// import './App.css';

function App() {
  return (
    <div className="App">
     <Navbar/>
    </div>
  );
}

export default App;
